import './ShowHideSection.css';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { generateClassName } from './helpers';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const ShowHideSection = ({ open, setOpen, header, children, className = null }) => {
    const [isOpen, setIsOpen] = useState(open);

    const toggleSection = () => {
        setIsOpen(!isOpen);
        setOpen(!isOpen);
    };

    return (
        <div
            className={generateClassName('show-hide', '-container', className)}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={toggleSection}
                className={generateClassName('show-hide', '-header', className)}
            >
                <div className='show-hide-header-component'>{header}</div>
                <div className='show-hide-header-toggle-icon'>{isOpen ? <ExpandLess /> : <ExpandMore />}</div>
            </div>
            {isOpen && (
                <div
                    className={generateClassName('show-hide', '-content', className)}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

ShowHideSection.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func.isRequired,
    header: PropTypes.node.isRequired,
    children: PropTypes.node
};

ShowHideSection.defaultProps = {
    open: false
};

export default ShowHideSection;